<template>
  <div class="mso-supplier-base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "msoSupplierBase",
};
</script>
